<div class="dl-replaybalk__knoppen">
    <button class="dl-replaybalk__knop" (click)="replay.naarBegin()" [disabled]="replay.eerste()"
            [title]="'REPLAY.EERSTE' | translate">
        <span class="fa-solid fa-angles-left"></span>
    </button>
    <button class="dl-replaybalk__knop" (click)="replay.terug()" [disabled]="replay.eerste()"
            [title]="'REPLAY.VORIGE' | translate">
        <span class="fa-solid fa-chevron-left"></span>
    </button>
    <button class="dl-replaybalk__knop" (click)="replay.verder()" [disabled]="replay.laatste()"
            [title]="'REPLAY.VOLGENDE' | translate">
        <span class="fa-solid fa-chevron-right"></span>
    </button>
    <button class="dl-replaybalk__knop" (click)="replay.naarEind()" [disabled]="replay.laatste()"
            [title]="'REPLAY.LAATSTE' | translate">
        <span class="fa-solid fa-angles-right"></span>
    </button>
    <button class="dl-replaybalk__knop" (click)="replay.stop()"
            [title]="'REPLAY.STOP' | translate">
        <span class="fa-solid fa-stop"></span>
    </button>
</div>
<div class="dl-replaybalk__teller">{{ replay.huidige() + 1 }} / {{ replay.aantal() }}</div>
